// import '../view-scans'

import { html, render } from 'lit';
import { uri, meta } from '../data-util';

// -------------------------------------
// Router will render view based on url
// -------------------------------------
export function router(view, lang, navi = 'push') {
  return async (dispatch, getState, api) => {
    // Needed for decision path
    const state = getState();
    // Shorter reference
    const body = $('main');
    // const body = document.body
    // Should connect this view to the body
    const viewChange = !view || view != uri.view();
    // Ensure view
    view = view || uri.view();
    // Remember previous view for show
    if (viewChange && false) {
      dispatch({ type: 'view.prev', data: view });
    }

    // Language has changed so rerender (dispatch)
    const langChange = lang && lang != uri.lang();
    // Ensure lang
    lang = lang || uri.lang();

    // ---------------------------
    // Server down
    // ---------------------------
    if (view == 'error') {
      await import('../view-error');
      render(html`<view-error></view-error>`, body);
    }

    // -------------------------------------
    // Too many drugs without authorization
    // -------------------------------------
    else if (view == 'not-authorized') {
      await import('../view-not-authorized');
      render(html`<view-not-authorized></view-not-authorized>`, body);
    }

    // ---------------------------
    // View status
    // ---------------------------
    else if (view == 'redirect-to-home') {
      if (process.env.NODE_ENV == 'production') {
        return location.assign(`https://${location.hostname}/`);
      } else {
        const hash = !!localStorage.getItem('token') ? `#/${localStorage.getItem('token')}` : '';
        return location.assign(`http://${location.hostname}:1234/`);
      }
    }

    // ---------------------------
    // View status
    // ---------------------------
    else if (view == 'redirect-to-status') {
      if (process.env.NODE_ENV == 'production') {
        return location.assign(`https://${location.hostname}/status/signin/${lang}/`);
      } else {
        const hash = !!localStorage.getItem('token') ? `#/${localStorage.getItem('token')}` : '';
        return location.assign(`http://${location.hostname}:5003/status/signin/${lang}/${hash}`);
      }
    }

    // -------------------------------
    // View start will explain limits
    // and motivation of service
    // -------------------------------
    else if (viewChange && view == 'start') {
      await import('../view-start');
      render(html`<view-start></view-start>`, body);
    }

    // -------------------------------------------------
    // View drug will search, list and edit substances
    // -------------------------------------------------
    else if (viewChange && view == 'drugs') {
      await import('../view-drugs');
      render(html`<view-drugs></view-drugs>`, body);
    }

    // -------------------------------------------------
    // View drug will search, list and edit substances
    // -------------------------------------------------
    else if (viewChange && view == 'findings') {
      await import('../view-findings');
      render(html`<view-findings></view-findings>`, body);
    }

    // ---------------------------
    // Views for Vorgehen
    // ---------------------------
    else if (viewChange && view == 'advice') {
      await import('../view-advice');
      render(html`<view-advice></view-advice>`, body);
    }

    // -----------------------------------------
    // View for FullScreen Scanner
    // -----------------------------------------
    // else if ( viewChange && view == "scans" ) {
    //   render( html `<view-scans></view-scans>`, body )
    // }

    // -----------------------------------------
    // View for FullScreen not in use currently
    // -----------------------------------------
    else if (viewChange && view == 'show') {
      await import('../view-show');
      render(html`<view-show></view-show>`, body);
    }

    // --------------------------------------
    // None of the above views
    // --------------------------------------
    else if (viewChange) {
      await import('../view-not-found');
      render(html`<view-not-found></view-not-found>`, body);
    }

    // -------------------------------------------------------------
    // Reset scrolling on manual navigation scrolling will persist
    // -------------------------------------------------------------
    if (viewChange) {
      // Scroll to top for next view only if not onload
      if (navi != 'replace') {
        document.documentElement.scrollTop = 0;
      }
      // Set url for view to be correct before rendering
      meta.canonical(view, lang, navi, state.xeon);
    }

    // Language changed, hide shortly the current view
    if (!viewChange && langChange) {
      dispatch({ type: 'view.hidden', data: true });
      meta.canonical(view, lang, navi, state.xeon);
      await new Promise((res) => setTimeout(res, 400));
      dispatch({ type: 'view.hidden', data: false });
    }

    return Promise.resolve();
  };
}
